import React from 'react';

import { type CurrencyCode } from '@/modules/currencies/constants';
import { getLocaleByLanguageAndLocation } from '@/modules/language/helpers';
import { useCurrentLanguage } from '@/modules/language/useCurrentLanguage';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';

type Props = {
  numberToFormat: number | string;
  currencyCode?: CurrencyCode;
  stripDecimalsIfWholeNumber?: boolean;
};

function LocaleCurrencyFormat({
  numberToFormat,
  currencyCode,
  stripDecimalsIfWholeNumber,
}: Props) {
  const { location } = useCurrentLocation();
  const { language } = useCurrentLanguage();

  const locale = getLocaleByLanguageAndLocation(language, location);

  //  If a product has no currency code, it has no price - this is a known issue. Checking here is a quick fix until we decide what to do about these products at a company level - Eli 10/23
  if (!currencyCode) {
    return <></>;
  }

  const value = Number(numberToFormat);
  const isWholeNumber = stripDecimalsIfWholeNumber && value % 1 === 0;

  return (
    <React.Fragment>
      {new Intl.NumberFormat(locale, {
        currency: currencyCode,
        style: 'currency',
        ...(isWholeNumber && {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }),
      }).format(value)}
    </React.Fragment>
  );
}

export { LocaleCurrencyFormat };
